import { render, staticRenderFns } from "./files.vue?vue&type=template&id=dd99878c&scoped=true&"
import script from "./files.vue?vue&type=script&lang=js&"
export * from "./files.vue?vue&type=script&lang=js&"
import style0 from "./files.vue?vue&type=style&index=0&id=dd99878c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd99878c",
  null
  
)

export default component.exports